<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import Card from '@/components/ui/card/Card.vue'
import CardDonutContent from '../ui/card/CardDonutContent.vue'
import SuiviCommandesRepository from '@/repository/SuiviCommandesRepository'
import type { RepartitionSuiviCommandeViewModel } from '@/lib/types'
import { formatNumber } from '@/lib/format'

const loading = ref<boolean>(true)
const repartitionData = ref<RepartitionSuiviCommandeViewModel[]>([])
const currentIndex = ref(0)
const itemsPerPage = 4

const processedData = computed(() => {
  if (!repartitionData.value?.length) return []

  return repartitionData.value.map((agence) => ({
    agence_title: agence.agence_title,
    data: [
      {
        name: 'Propositions acceptées',
        value: agence.proposition_acceptees.value,
        color: '#98D89E', // Vert clair
      },
      {
        name: 'Propositions en relance',
        value: agence.proposition_relance.value,
        color: '#FF9898', // Rose saumon
      },
      {
        name: 'Propositions rejetées',
        value: agence.proposition_rejete.value,
        color: '#FF5656', // Rouge vif
      },
    ],
  }))
})

const canGoLeft = computed(() => currentIndex.value > 0)
const canGoRight = computed(() => {
  const total = processedData.value.length
  return (currentIndex.value + 1) * itemsPerPage < total
})

const navigate = (direction: 'left' | 'right') => {
  if (direction === 'left' && canGoLeft.value) {
    currentIndex.value--
  } else if (direction === 'right' && canGoRight.value) {
    currentIndex.value++
  }
}

onMounted(async () => {
  repartitionData.value = await SuiviCommandesRepository.getRepartitionData()
  loading.value = false
})
</script>

<template>
  <Card
    title="Répartition par agence"
    :download-chart="{
      selector: '.grid-cols-4',
      filename: 'repartition-commandes.png',
    }"
  >
    <CardDonutContent
      :loading="loading"
      :data="processedData"
      :current-index="currentIndex"
      :items-per-page="itemsPerPage"
      :can-go-left="canGoLeft"
      :can-go-right="canGoRight"
      :value-formatter="formatNumber"
      total-label="propositions<br>créées"
      :show-currency="false"
      @navigate="navigate"
    />
  </Card>
</template>
